angular.module('SpidApp')

.factory('ResetPasswordMailer', ['Mailer', function (Mailer) {
    /*
        ResetPassMailer extends Mail.
        It only needs a 'to' and a 'newPassword' param
        and name !
    */
    var ResetPasswordMailer = function (params) {
        params = params || {}
        
        var newPassword = params.newPassword
        if (!newPassword || newPassword.length === 0) {
            throw 'ResetPasswordMailer() - Missing parameters (newPassword)'
        }
        Mailer.call(this, params)
        
        this.subject = ResetPasswordMailer.DEFAULT_SUBJECT
        this.message = ResetPasswordMailer.DEFAULT_MESSAGE
            .replace('{{newPassword}}', newPassword)
    }
    
    ResetPasswordMailer.DEFAULT_SUBJECT = 'Spid Escaleo - Votre mot de passe a été changé'
    ResetPasswordMailer.DEFAULT_MESSAGE = 'Voici votre nouveau mot de passe\n\n{{newPassword}}\n\nL\'équipe de developpement Laposte'
    
    // Inheritance stuff
    ResetPasswordMailer.prototype = Object.create(Mailer.prototype)
    ResetPasswordMailer.prototype.constructor = ResetPasswordMailer
    
    return ResetPasswordMailer
}])
